import React, { createContext, useRef } from 'react';
import { IntlProvider as ReactIntlProvider, useIntl } from 'react-intl';
import { warning } from '@jutro/logger';
import debounce from "lodash/debounce";
export const IntlContext = createContext(undefined);
const ReactIntlConsumer = ({
  children
}) => {
  const intl = useIntl();
  return React.createElement(IntlContext.Provider, {
    value: intl
  }, children);
};
export const IntlProvider = ({
  defaultLocale,
  locale,
  messages,
  textComponent,
  children
}) => {
  const bulkErrors = useRef({
    locale: '',
    ids: []
  });
  const deferWarning = useRef(debounce(() => {
    warning(`${bulkErrors.current.locale} locale translations are not provided or missing next ${bulkErrors.current.ids.length} id's: ${bulkErrors.current.ids.join(', ')}`);
    bulkErrors.current = {
      locale: '',
      ids: []
    };
  }, 500));
  const ammend = errMeg => {
    const missingId = errMeg.match(/Missing message: "(.*)" for locale "(.*)"/);
    if (missingId) {
      bulkErrors.current.locale = bulkErrors.current.locale || missingId[2];
      bulkErrors.current.ids.push(missingId[1]);
      deferWarning.current();
    }
  };
  return React.createElement(ReactIntlProvider, {
    onError: err => ammend(err.message),
    defaultLocale: defaultLocale,
    locale: locale,
    messages: messages,
    textComponent: textComponent
  }, React.createElement(ReactIntlConsumer, null, children));
};
IntlProvider.displayName = 'IntlProvider';
ReactIntlConsumer.__docgenInfo = {
  componentName: "ReactIntlConsumer",
  packageName: "@jutro/locale",
  description: "",
  displayName: "ReactIntlConsumer",
  methods: [],
  actualName: "ReactIntlConsumer"
};
IntlProvider.__docgenInfo = {
  componentName: "IntlProvider",
  packageName: "@jutro/locale",
  description: "",
  displayName: "IntlProvider",
  methods: [],
  actualName: "IntlProvider"
};